// @flow

const tagReadonlyStyles = {
  chip: {
    margin: '2px',
    transition: 'opacity 0.2s, transform 0.2s'
  },
  
  removing: {
    opacity: 0.5,
    transform: 'scale(0.95)'
  },

  tagContainer: (theme, { tag, size, variant, isRemoving }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    backgroundColor: tag?.color || tag?.Color || '#9e9e9e',
    color: tag && isDarkColor(tag.color || tag.Color) ? 'white' : 'black',
    fontSize: size === 'small' ? '0.75rem' : theme.typography?.content?.fontSize || '0.875rem',
    height: size === 'small' ? '20px' : '24px',
    padding: '0 8px',
    borderRadius: '12px',
    marginRight: '4px',
    cursor: 'pointer',
    boxShadow: variant === 'outlined' ? 'none' : '0 1px 2px rgba(0,0,0,0.1)',
    border: variant === 'outlined' ? '1px solid #ddd' : 'none',
    opacity: isRemoving ? 0.5 : 1,
    transition: 'opacity 0.2s',
    whiteSpace: 'nowrap',
    flexShrink: 0
  }),

  tagName: {
    marginRight: '4px',
    whiteSpace: 'nowrap'
  },

  removeIcon: (theme, size) => ({
    cursor: 'pointer',
    marginLeft: '2px',
    fontSize: size === 'small' ? '10px' : '1.2rem',
    fontWeight: 'bold',
    opacity: 0.3,
    transition: 'opacity 0.2s ease'
  })
};

// Helper function to determine if a color is dark
function isDarkColor(color: ?string): boolean {
  if (!color) return false;

  // Remove the leading # if it exists
  let colorValue = color.startsWith('#') ? color.slice(1) : color;

  // Ensure 6 digit hex color
  if (colorValue.length === 3) {
    colorValue = colorValue.split('').map(c => c + c).join('');
  }

  // Fallback to default if color is invalid
  if (!/^[0-9A-F]{6}$/i.test(colorValue)) {
    return false;
  }

  try {
    const invert = require('invert-color');
    // Use a higher threshold (0.3) for better readability on saturated colors
    // Default threshold (0.179) is too low for colors like #e91e63 (pink)
    const bwOptions = { black: '#000000', white: '#ffffff', threshold: 0.3 };
    const invertedBW = invert(`#${colorValue}`, bwOptions);
    return invertedBW.toLowerCase() === '#ffffff';
  } catch (e) {
    return false;
  }
}

export default tagReadonlyStyles;
export { isDarkColor }; 